import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const articleProofApi = generateProofApi('/proof-file/article');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('article', articleProofApi);

export function getArticleProofsByOwnerOptions(articleId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(articleId, userId);
}

export function getArticleProofsOptions(articleId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(articleId);
}

export function useUploadOrUpdateArticleProof(articleId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(articleId, queryClient));
}

export function useDeleteArticleProof(articleId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(articleId, queryClient));
}
